<template>
  <div id="salesBox">
    <div :class="saleBoxNone" @mouseenter="getSaleList" v-if="salesFixed">
      <div class="saleBox">
        <div class="triangle"></div>
        <div class="content">
          <span class="text">专属销售体验师</span>
          <span class="icon"> </span>
        </div>
      </div>
    </div>
    <div :class="saleListNone" @mouseleave="isShowDetail = false">
      <div class="saleList">
        <p class="headerText">专属顾问咨询</p>
        <ul>
          <li
            v-for="(item, index) in salerList"
            :key="item.mobile"
            class="liItem"
            @mouseleave="ItemNoneQrcode(item, index)"
          >
            <div :class="activityIndex === index ? 'showQrcode' : ''">
              <div class="showSalers">
                <img class="avatar" :src="item.imgUrl" alt="" />
                <div class="RightText">
                  <p class="name">{{ item.name || item.mobile }}</p>
                  <p>{{ item.address }}</p>
                  <p class="enquiry" @mouseenter.self="ItemShowQrcode(item, index)">询价</p>
                </div>
              </div>
            </div>
            <div class="counsel" :class="activityIndex === index ? 'showIt' : ''">
              <div class="show-qrcode">
                <img :src="salerList[activityIndex] && salerList[activityIndex].qrcode" alt="" />
                <p>微信扫码咨询</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getStorage } from '@/lib/utils'
import getData from '@/api/details'
import defaultAvatar from '../../../assets/images/mall/salesman-avatar.png'
export default {
  data() {
    return {
      defaultAvatar,
      isShowDetail: false,
      isShowQrcode: false,
      activityIndex: -1,
      cityId: '',
      qrcode: '',
      salerList: [],
      salesFixed: true,
      timeOut: null,
      leaveTimeOut: null
    }
  },
  props: {
    orgId: {
      default: ''
    }
  },
  computed: {
    saleBoxNone() {
      return {
        'salebox-none': this.isShowDetail
      }
    },
    saleListNone() {
      return {
        'saleList-none': !this.isShowDetail
      }
    }
  },
  methods: {
    // handleScroll() {
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   var offsetTop = document.querySelector('#salesBox').offsetTop
    //   if (scrollTop > offsetTop) {
    //     this.salesFixed = true
    //   } else {
    //     this.salesFixed = false
    //   }
    // },
    getSaleList() {
      if (this.leaveTimeOut) clearTimeout(this.leaveTimeOut)
      if (this.timeOut) clearTimeout(this.timeOut)
      this.isShowDetail = true
      const params = {
        number: 4,
        cityCode: this.orgId || !this.cityId ? '' : this.cityId,
        orgId: this.orgId ? this.orgId : ''
        // cityCode: '',
        // orgId: ''
      }
      getData.getSaleList(params).then((res) => {
        if (res.status === 200) {
          const list = res.data.splice(0, 4).map((item) => {
            item.imgUrl = item.imgUrl ? item.imgUrl : defaultAvatar
            return item
          })
          this.salerList = list
        }
      })
    },
    ItemShowQrcode(item, i) {
      if (this.leaveTimeOut) clearTimeout(this.leaveTimeOut)
      if (this.timeOut) clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        if (item.qrcode) {
          this.activityIndex = i
          return
        }
        getData.getSaleQrcode(item.aabbcc).then((res) => {
          if (res.status === 200) {
            this.timeOut = null
            this.activityIndex = i
            item.isShowQrcode = true
            item.qrcode = res.data
            this.$set(this.salerList, i, item)
          }
        })
      }, 50)
    },
    ItemNoneQrcode(item, i) {
      if (this.leaveTimeOut) clearTimeout(this.leaveTimeOut)
      if (this.timeOut) clearTimeout(this.timeOut)
      this.leaveTimeOut = setTimeout(() => {
        this.activityIndex = -1
        item.isShowQrcode = false
        this.leaveTimeOut = null
        this.$set(this.salerList, i, item)
      }, 50)
    }
  },
  created() {
    let code = getStorage('dtmAdcode')
    if (code) {
      this.cityId = ('' + code).slice(0, 4).padEnd(6, '0')
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss" scoped>
.saleBox {
  float: right;
  width: 50px;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 10000;
  background: url('../../../assets/images/mall/bg-ex.png');
  color: #fff;
  cursor: pointer;
  transition: all 500ms linear 0ms;
  .content {
    padding: 36px 17px 13px;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    .icon {
      display: inline-block;
      width: 17px;
      height: 18px;
      margin-top: 10px;
      background: url('../../../assets/images/mall/left-triangle.png');
      background-size: 100%;
    }
  }
}
.salebox-none {
  .saleBox {
    opacity: 0;
    width: 0;
    transition: width 500ms linear, opacity 500ms linear;
  }
}
.saleList-none {
  .saleList {
    position: fixed;
    right: -300px;
  }
}
.saleList {
  // float: right;
  width: 300px;
  height: 587px;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 100000;
  background: #fff;
  border: 1px solid rgba(208, 208, 208, 1);
  transition: right 500ms linear 0ms;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  .headerText {
    box-sizing: border-box;
    margin: 20px 15px;
  }
  ul {
    box-sizing: border-box;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .liItem {
    background: #fff;
    margin: 0 0 10px 5px;
    position: relative;
    .showSalers {
      opacity: 1;
      display: flex;
      align-content: center;
    }
    .avatar {
      transition: opacity 200ms linear 0ms;
    }
    .name {
      transition: opacity 200ms linear 0ms;
    }
    .showQrcode {
      .avatar {
        opacity: 0;
      }
      .name {
        opacity: 0;
      }
    }
    img {
      display: inline-block;
      width: 120px;
      height: 120px;
    }
    .RightText {
      display: inline-block;
      margin-left: 15px;
      height: 120px;
      position: relative;
      top: 0;
      width: 150px;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      p:first-child {
        margin-top: 3px;
        height: 16px;
      }
      p:nth-child(2) {
        margin: 9px 0 11px 0;
        color: #666;
      }
      .enquiry {
        width: 123px;
        height: 32px;
        background: rgba(198, 0, 31, 1);
        color: #fff;
        text-align: center;
        cursor: pointer;
        margin: 8px 0;
        line-height: 32px;
      }
    }
  }

  .show-qrcode {
    position: absolute;
    top: 0;
    display: flex;
    align-content: center;
    img {
      display: inline-block;
      width: 120px;
      height: 120px;
      z-index: 1000;
    }
    p {
      display: inline-block;
      margin-left: 15px;
      position: absolute;
      left: 120px;
      width: 150px;
      top: 3px;
    }
  }
  .counsel {
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
  .showIt {
    opacity: 1;
  }
}
</style>
